import React from 'react';
import { Box, Typography, Chip, Divider } from '@mui/material';
import { eventOptions } from '../../data/profileQuestions';

interface Props {
  selectedSports: string[];
  selectedNonSports: string[];
  onChange: (sports: string[], nonSports: string[]) => void;
}

const EventSelector: React.FC<Props> = ({ selectedSports, selectedNonSports, onChange }) => {
  const toggleSports = (item: string) => {
    const next = selectedSports.includes(item)
      ? selectedSports.filter((s) => s !== item)
      : [...selectedSports, item];
    onChange(next, selectedNonSports);
  };

  const toggleNonSports = (item: string) => {
    const next = selectedNonSports.includes(item)
      ? selectedNonSports.filter((s) => s !== item)
      : [...selectedNonSports, item];
    onChange(selectedSports, next);
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        経験したイベント
      </Typography>
      <Typography variant="body2" sx={{ mb: 2, color: '#666' }}>
        これまでに経験したことを選んでください（複数選択可）
      </Typography>

      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#0066cc' }}>
        競技関連
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 3 }}>
        {eventOptions.sports.map((item) => (
          <Chip
            key={item}
            label={item}
            onClick={() => toggleSports(item)}
            color={selectedSports.includes(item) ? 'primary' : 'default'}
            variant={selectedSports.includes(item) ? 'filled' : 'outlined'}
            sx={{ fontSize: '0.85rem', py: 2 }}
          />
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: '#ff9800' }}>
        競技外
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {eventOptions.nonSports.map((item) => (
          <Chip
            key={item}
            label={item}
            onClick={() => toggleNonSports(item)}
            color={selectedNonSports.includes(item) ? 'secondary' : 'default'}
            variant={selectedNonSports.includes(item) ? 'filled' : 'outlined'}
            sx={{ fontSize: '0.85rem', py: 2 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default EventSelector;
